import { IHeiPromotionData } from './hei-promotion.data';
import { IHeiPromotionProps } from './hei-promotion.props.autogenerated';
import MsDyn365 from '@msdyn365-commerce/core';

export type IHeiPromotionViewProps = IHeiPromotionProps<IHeiPromotionData> & {
    promotionId: string;
};

const HeiPromotion = (props: IHeiPromotionProps<IHeiPromotionData>) => {
    if (!MsDyn365.isBrowser) {
        return null;
    }

    const segments = location.pathname.split('/');
    const promoId = segments[segments.length - 1];

    if (!promoId) {
        return null;
    }

    return props.renderView({
        ...props,
        promotionId: promoId
    });
};

export default HeiPromotion;
